import { Col, List, Row } from "antd";
import styles from "./LiveStream.module.css";
import { SubmitButton, TextComponent } from "../../../../../components";
import { useEffect, useRef, useState } from "react";
import Modal from "../../../../../components/modal/Modal";
import { useLocation, useNavigate } from "react-router-dom";
import avatarImg from "../../../../../assets/avatar.png";
import redDotImg from "../../../../../assets/redDot.png";
import eyeIcon from "../../../../../assets/eyeIcon.png";
import { useDispatch, useSelector } from "react-redux";
import {
  LocalUser,
  RemoteUser,
  useClientEvent,
  useJoin,
  useLocalCameraTrack,
  useLocalMicrophoneTrack,
  usePublish,
  useRTCClient,
  useRemoteAudioTracks,
  useRemoteUsers,
  useNetworkQuality,
} from "agora-rtc-react";
import { EventMiddleware } from "../../../../../Store/Middlewares/EventMiddleware";
import Pusher from "pusher-js";
import { getLiveChannelData } from "../../../../../Store/Actions/EventAction";
import moment from "moment";
import { FaUsers } from "react-icons/fa";

const closeIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 66 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ zIndex: 50, position: "relative" }}
  >
    <path
      d="M33.0374 37.1222L42.4597 46.4747C43.0553 47.0659 43.8134 47.3615 44.734 47.3615C45.6546 47.3615 46.4127 47.0659 47.0084 46.4747C47.604 45.8834 47.9018 45.1309 47.9018 44.2172C47.9018 43.3034 47.604 42.5509 47.0084 41.9597L37.5861 32.6072L47.0084 23.2548C47.604 22.6635 47.9018 21.911 47.9018 20.9973C47.9018 20.0836 47.604 19.3311 47.0084 18.7398C46.4127 18.1486 45.6546 17.8529 44.734 17.8529C43.8134 17.8529 43.0553 18.1486 42.4597 18.7398L33.0374 28.0923L23.6152 18.7398C23.0195 18.1486 22.2614 17.8529 21.3408 17.8529C20.4203 17.8529 19.6621 18.1486 19.0665 18.7398C18.4708 19.3311 18.173 20.0836 18.173 20.9973C18.173 21.911 18.4708 22.6635 19.0665 23.2548L28.4887 32.6072L19.0665 41.9597C18.4708 42.5509 18.173 43.3034 18.173 44.2172C18.173 45.1309 18.4708 45.8834 19.0665 46.4747C19.6621 47.0659 20.4203 47.3615 21.3408 47.3615C22.2614 47.3615 23.0195 47.0659 23.6152 46.4747L33.0374 37.1222ZM33.0374 64.8571C28.5429 64.8571 24.3191 64.01 20.3661 62.3158C16.4131 60.6216 12.9745 58.3243 10.0504 55.424C7.12621 52.5215 4.8118 49.1084 3.10713 45.1847C1.40246 41.2609 0.549041 37.0685 0.546875 32.6072C0.546875 28.146 1.40029 23.9535 3.10713 20.0298C4.81397 16.1061 7.12838 12.693 10.0504 9.79049C12.9745 6.88801 16.4131 4.59075 20.3661 2.89871C24.3191 1.20667 28.5429 0.359572 33.0374 0.357422C37.5319 0.357422 41.7557 1.20452 45.7087 2.89871C49.6617 4.5929 53.1003 6.89016 56.0245 9.79049C58.9486 12.693 61.2641 16.1061 62.971 20.0298C64.6778 23.9535 65.5301 28.146 65.528 32.6072C65.528 37.0685 64.6745 41.2609 62.9677 45.1847C61.2609 49.1084 58.9465 52.5215 56.0245 55.424C53.1003 58.3265 49.6617 60.6248 45.7087 62.319C41.7557 64.0132 37.5319 64.8592 33.0374 64.8571ZM33.0374 58.4071C40.2936 58.4071 46.4398 55.9077 51.4758 50.909C56.5118 45.9103 59.0299 39.8097 59.0299 32.6072C59.0299 25.4048 56.5118 19.3042 51.4758 14.3055C46.4398 9.30675 40.2936 6.80739 33.0374 6.80739C25.7812 6.80739 19.6351 9.30675 14.599 14.3055C9.563 19.3042 7.04498 25.4048 7.04498 32.6072C7.04498 39.8097 9.563 45.9103 14.599 50.909C19.6351 55.9077 25.7812 58.4071 33.0374 58.4071Z"
      fill="#fff"
    />
  </svg>
);

const shareIcon = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0392 15.6811C19.8387 15.6811 18.7588 16.1655 17.9921 16.9386L9.03356 12.7319C9.06437 12.5342 9.08559 12.3342 9.08559 12.1283C9.08559 11.9277 9.06538 11.732 9.03609 11.5397L17.9815 7.37896C18.7487 8.1584 19.8336 8.64767 21.0392 8.64767C23.3636 8.64767 25.2481 6.84028 25.2481 4.61095C25.2481 2.38113 23.3636 0.574219 21.0392 0.574219C18.7149 0.574219 16.8304 2.38113 16.8304 4.61095C16.8304 4.8115 16.8506 5.00672 16.8799 5.19952L7.93452 9.36026C7.1673 8.58082 6.0829 8.09155 4.87678 8.09155C2.55191 8.09155 0.667969 9.89895 0.667969 12.1283C0.667969 14.3581 2.55191 16.165 4.87678 16.165C6.07735 16.165 7.1572 15.6806 7.92391 14.9074L16.8825 19.1142C16.8517 19.3114 16.8304 19.5119 16.8304 19.7178C16.8304 21.9476 18.7149 23.7545 21.0392 23.7545C23.3636 23.7545 25.2481 21.9476 25.2481 19.7178C25.2481 17.488 23.3636 15.6811 21.0392 15.6811Z"
      fill="#ED73AA"
    />
  </svg>
);

const WatchingModal = ({ LiveChannelData }) => {
  return (
    <>
      <Row>
        <Col xs={24}>
          <TextComponent textClass={styles.modalHeading}>People Watching</TextComponent>
        </Col>
      </Row>
      <div>
        <List
          dataSource={LiveChannelData?.users ? LiveChannelData?.users : []}
          style={{ flex: 1 }}
          locale={{ emptyText: " " }}
          renderItem={(item, index) => (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
              <img src={item?.image ? item?.image : avatarImg} alt="" className={styles.avatarImg} />
              <TextComponent style={{ marginLeft: 10, color: 'black' }} >
                {item?.name}
              </TextComponent>
            </div>
          )}
        />
      </div>

    </>
  );
};


const LiveStream = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [liveData, setLiveData] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const LiveChannelData = useSelector(
    state => state.EventReducer.liveChannelData,
  );

  const location = useLocation();
  const chatData = location?.state?.data
  const config = {
    appId: '139bdabf155141fb810a1c0de545dd58',
    token: chatData?.token,
    channelName: chatData?.channel_name,
    eventId: chatData?.event_id,
  };

  const BroadcastStarted = chatData?.created_at
    ? chatData?.created_at
    : null;

  const [timeStarted, setTimeStarted] = useState();
  const [deviceTime, setDeviceTime] = useState(new Date());

  const [activeConnection, setActiveConnection] = useState(true);
  const [micOn, setMic] = useState(true);
  const [cameraOn, setCamera] = useState(true);
  const { localMicrophoneTrack } = useLocalMicrophoneTrack(micOn);
  const { localCameraTrack } = useLocalCameraTrack(cameraOn);
  const { uplinkNetworkQuality } = useNetworkQuality();

  const liveChannel = useRef(null);
  const [isHost, setIsHost] = useState(chatData?.is_host);


  useJoin(
    {
      appid: config.appId,
      channel: config.channelName,
      token: config.token,
    },
    activeConnection,
  );

  usePublish([localMicrophoneTrack, localCameraTrack]);
  const remoteUsers = useRemoteUsers();
  const { audioTracks } = useRemoteAudioTracks(remoteUsers);

  audioTracks.forEach((track) => track.play());

  const leaveChannel = async () => {

    setActiveConnection(false)
    navigate(-1)
  };

  const endBroadcast = () => {
    let userData = {
      event_id: config.eventId,
    };
    if (isHost) {
      dispatch(EventMiddleware.endBroadcast(userData)).then(data => {
        leaveChannel();
      });
    }
  };
  const leaveBroadcast = () => {
    let userData = {
      event_id: config.eventId,
    };
    if (!isHost) {
      dispatch(EventMiddleware.leaveStrean(userData)).then(data => {
        leaveChannel();
        dispatch(getLiveChannelData([]));
      });
    }
  };

  const agoraEngine = useRTCClient();

  const initiatePusher = () => {
    let pusher = new Pusher('ac81b678f2fe61e8c6eb', { cluster: 'mt1' });
    liveChannel.current = pusher.subscribe(config?.eventId?.toString());
    liveChannel.current.bind('App\\Events\\EventBroadcastViewers', data => {
      dispatch(getLiveChannelData(data));
      if (data?.is_broadcast_end == true) {
        if (!isHost) {
          leaveChannel();
        }
      }
    });
  };

  useEffect(() => {
    if (activeConnection) {
      agoraEngine.setClientRole(isHost ? "host" : "audience")
      initiatePusher()
    }
  }, []);

  useEffect(() => {
    setInterval(function () {
      const time = new Date().getTime() - deviceTime.getTime();
      setTimeStarted(time);
    }, 1000);
  }, []);



  function liveClick() {
    if (activeConnection) {
      setLiveData(true);
    }
  }

  useEffect(() => {
    document.body.addEventListener("click", liveClick);

    return () => {
      document.body.removeEventListener("click", liveClick);
    };
  }, [activeConnection]);

  useEffect(() => {
    if (activeConnection) {
      setTimeout(() => {
        setLiveData(false);
      }, 5000);
    }
  }, [liveData]);


  return (
    <div className={styles.container}>
      {
        isHost ?
          <div className={styles.videoBg}>
            <LocalUser
              audioTrack={localMicrophoneTrack}
              videoTrack={localCameraTrack}
              cameraOn={cameraOn}
              micOn={micOn}
              playAudio={false}
              playVideo={cameraOn}
              style={{ height: '100%' }}

            />
          </div>
          :
          remoteUsers.map((remoteUser) => (
            <div className={styles.videoBg} key={remoteUser.uid}>
              <RemoteUser user={remoteUser} playVideo={true} playAudio={true} />
            </div>
          ))

      }
      <div className={styles.pinkBg}></div>

      {liveData &&
        <Row className={styles.liveInfoContainer}>
          <Row className={styles.infoRow}>
            <Col>
              <Row className={styles.liveIndicator}>
                <img src={redDotImg} alt="" className={styles.redDotImg} />
                <TextComponent>Live</TextComponent>
              </Row>
            </Col>
            <Col>
              <TextComponent textClass={styles.timeDuration}>
                {timeStarted &&
                  moment.utc(timeStarted).format('HH:mm:ss')}
              </TextComponent>
            </Col>
            <Col>
              <Row className={styles.signalIndicator}>
                <TextComponent>{
                  uplinkNetworkQuality <= 4
                    ? 'Good Signal'
                    : uplinkNetworkQuality > 4
                      ? 'Bad Signal'
                      : 'Calculating..'}</TextComponent>
              </Row>
            </Col>
          </Row>
          <Row className={styles.infoRow}>
            <Col>
              <Row className={styles.iconBtn} onClick={() => setModalOpen(true)}>
                <FaUsers size={20} color="var(--primary-color)" />
              </Row>
            </Col>

            <Col>

              <Row>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <img src={chatData?.event_image ? chatData?.event_image : avatarImg} alt="" className={styles.avatarImg} />
                  <TextComponent style={{ marginLeft: 10 }} textClass={styles.liveTitle}>
                    {chatData?.event_name}
                  </TextComponent>
                </div>
              </Row>
              <Row>
                <TextComponent textClass={styles.liveText}>
                  {isHost ? `Stream Live | ${LiveChannelData?.total_viewers
                    ? LiveChannelData?.total_viewers : 0} viewers` :
                    `You & ${LiveChannelData?.total_viewers
                      ? LiveChannelData?.total_viewers - 1
                      : 0
                    } Guests Are Watching`}
                </TextComponent>
              </Row>
              <Row style={{ marginTop: 20 }}>
                <SubmitButton
                  title={isHost ? "End Stream" : "Leave Stream"}
                  btnClass={styles.btn}
                  onClick={() => { isHost ? endBroadcast() : leaveBroadcast() }}
                />
              </Row>
            </Col>
            <Col>
              <Row className={styles.viewsIndicator}>
                <img src={eyeIcon} alt="" className={styles.redDotImg} />
                <TextComponent>{LiveChannelData?.total_viewers
                  ? LiveChannelData?.total_viewers
                  : 0}</TextComponent>
              </Row>
            </Col>
          </Row>
        </Row>
      }

      <Modal
        isModalOpen={modalOpen}
        setIsModalOpen={setModalOpen}
        closable={true}
        wideModal={true}
        className={styles.modalContent}
      >
        <WatchingModal LiveChannelData={LiveChannelData} />
      </Modal>
    </div>
  );
};

export default LiveStream;
